import {
  SET_FORM_DATA,
} from "../types";

export const authStates = {
  email: null,
  password: null,
};

export const authReducer = (state, action) => {
  switch (action.type) {
    case SET_FORM_DATA:
      return {
        ...state,
        ...action.data
      };
    default: return state
  }
};